module.exports = __webpack_public_path__ + "static/img/background.1383197e.svg";